module.exports = __webpack_public_path__ + "static/twitter-image-c615e7c521cb06dc6e204394ddefd83b.jpg";